import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { get } from 'lodash'
import { OfficeDetails } from 'containers/forms/national-offices'
import { Contacts } from 'containers/pages'
import { SubTabs, SubTab } from 'components/layout'
import { meta } from 'helpers/decorators'
import { apiCodeLists, apiDownloadFile, apiConfiguration } from 'helpers/decorators/api'
import OfficeLabels from '../Labels/OfficeLabels'
import { CONFIGURATION_KEYS } from '../../../constants/enums'


const enhance = compose(
  meta({
    title: 'Detail',
    intlKey: 'pageTitle.detail',
    dynamicProp: 'organizations.detail.name',
    dynamicPropId: 'organizations.detail.globalId'
  }),
    apiConfiguration({
        getValues: [
            CONFIGURATION_KEYS.enableOrganizationLabels.id,
            CONFIGURATION_KEYS.isGOPEnabled.id

        ]
    }),
  apiDownloadFile(),
  apiCodeLists(['titles', 'phoneTypes', 'organizationStates']),
  connect(({ api, auth }) => ({
    blobs: api.blobs,
    activeOrganization: auth.organization
  }))
)

class OrganizationDetail extends Component {
  render() {
      const { activeOrganization, configuration } = this.props

      const isOrganizationLabelsEnabled = get(configuration,`valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableOrganizationLabels.id}].booleanValue`)

    return (
      <SubTabs>
        <SubTab title="Office details" intlKey="tabs.office_details">
          <OfficeDetails {...this.props} />
        </SubTab>
        <SubTab title="Office details" intlKey="tabs.related_contacts">
          <Contacts {...this.props} />
        </SubTab>
          {isOrganizationLabelsEnabled && <SubTab title="Labels" intlKey="tabs.labels">
           <OfficeLabels {...this.props} hideAction />
        </SubTab>}
      </SubTabs>
    )
  }
}

export default enhance(OrganizationDetail)
